import ServiceApi from 'vl-common/src/services/service.api';

export const rescheduleConfirm = (request) => {
  return async () => {
    const ret = await ServiceApi.post('/booking/appointment/reschedule', { ...request })
      .then(({ data }) => ({ type: 'RESCHEDULE_CONFIRM_SUCCESS', payload: data }))
      .catch((e) => {
        console.error(e);
        return { type: 'RESCHEDULE_CONFIRM_FAIL', error: e.response };
      });

    return ret;
  };
};
